import { ResponseError } from "@lucaswickstrom/fetch";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useError } from "./index.js";
export async function setMessage(err) {
    if (err instanceof ResponseError) {
        const data = await err.response.json();
        // @ts-ignore
        err.message = data?.error?.message || err.message;
    }
    return err;
}
export function useQueryError(queryError, onError) {
    const { addError } = useError();
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    useEffect(() => {
        if (queryError && !onError?.(queryError)) {
            setMessage(queryError).then((errorWithMessage) => {
                addError(errorWithMessage);
            });
        }
    }, [queryError]);
}
export function useQueryWithError(queryKey, queryFn, queryOptions, onError) {
    const queryResult = useQuery({ queryKey, queryFn, ...queryOptions });
    useQueryError(queryResult.error, onError);
    return queryResult;
}
export function useMutationWithError(mutationKey, mutationFn, mutationOptions, onError) {
    const queryResult = useMutation({
        mutationKey,
        mutationFn,
        ...mutationOptions,
    });
    useQueryError(queryResult.error, onError);
    return queryResult;
}
//# sourceMappingURL=QueryError.js.map